export const childrenOptions = [
	{
		value: 1,
		name: '1',
	},
	{
		value: 2,
		name: '2 a více',
	},
];
